import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import {connect} from 'react-redux';

import KeyBoardComponent from '../components/key-gamepad/key-gamepad.jsx';
import {setStageCover, setWorkButState} from "../reducers/vm-status";


class Content extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'filterKeyboardType',
            'handleKeyPress',
            'handleKeyUp'
        ]);
        this.state = {
            keyboard: 1,
            nowWith: document.documentElement.clientWidth,
            nowHeight: document.documentElement.clientHeight,
            keyCode: [
                {key: 'a', code: 65},
                {key: 'b', code: 66},
                {key: 'c', code: 67},
                {key: 'd', code: 68},
                {key: 'e', code: 69},
                {key: 'f', code: 70},
                {key: 'g', code: 71},
                {key: 'h', code: 72},
                {key: 'i', code: 73},
                {key: 'j', code: 74},
                {key: 'k', code: 75},
                {key: 'l', code: 76},
                {key: 'm', code: 77},
                {key: 'n', code: 78},
                {key: 'o', code: 79},
                {key: 'p', code: 80},
                {key: 'q', code: 81},
                {key: 'r', code: 82},
                {key: 's', code: 83},
                {key: 't', code: 84},
                {key: 'u', code: 85},
                {key: 'v', code: 86},
                {key: 'w', code: 87},
                {key: 'x', code: 88},
                {key: 'y', code: 89},
                {key: 'z', code: 90},
                {key: '0', code: 48},
                {key: '1', code: 49},
                {key: '2', code: 50},
                {key: '3', code: 51},
                {key: '4', code: 52},
                {key: '5', code: 53},
                {key: '6', code: 54},
                {key: '7', code: 55},
                {key: '8', code: 56},
                {key: '9', code: 57},
                {key: 'ArrowUp', code: 38},
                {key: 'ArrowDown', code: 40},
                {key: 'ArrowLeft', code: 37},
                {key: 'ArrowRight', code: 39},
                {key: ' ', code: 32},
                {key: 'any', code: 111}
            ]
        };
    }

    filterKeyboardType() {
        const keyboard = this.props.keyboard;
        const keyboardDeleteAny = keyboard.filter(i => i !== 'any');
        if (keyboard.length === 0) {
            return 0;
        }

        if (keyboard.length > 0 && keyboard.length <= 3) {
            return 29;
        }

        if (keyboardDeleteAny.length === 4) {
            if (keyboardDeleteAny.every(item => ['left arrow', 'up arrow', 'down arrow', 'right arrow'].indexOf(item) > -1)) return 27;
            if (keyboardDeleteAny.every(item => ['w', 'a', 's', 'd'].indexOf(item) > -1)) return 28;
        }

        if (keyboardDeleteAny.length >= 4 && keyboardDeleteAny.length <= 10) {
            const game1 = ['w', 'a', 's', 'd', 'left arrow', 'up arrow', 'down arrow', 'right arrow', 'space', '0'];
            const game2 = ['w', 'a', 's', 'd', 'q', 'e', 'z', 'x', 'space', 'c'];
            const game3 = ['left arrow', 'up arrow', 'down arrow', 'right arrow', '1', '2', '3', '4', '5', '6'];
            if (keyboardDeleteAny.every(item => game1.indexOf(item) > -1)) return 21;
            if (keyboardDeleteAny.every(item => game2.indexOf(item) > -1)) return 22;
            if (keyboardDeleteAny.every(item => game3.indexOf(item) > -1)) return 23;
        }

        if (keyboardDeleteAny.length >= 4) {
            const word = /^[a-z]+$/;
            const number = /^\d+$/;
            if (keyboardDeleteAny.every(item => word.test(item))) return 10;
            if (keyboardDeleteAny.every(item => number.test(item))) return 30;
        }

        return -1;
    }

    handleKeyPress (key) {
        if (key) {
            let keyboardList = [];
            const keyCode = this.state.keyCode.find(item => item.key === key).code;
            this.props.keyboard.forEach(item => {
                if (item === 'space') {
                    keyboardList.push(' ');
                } else if (item === 'down arrow') {
                    keyboardList.push('ArrowDown');
                } else if (item === 'left arrow') {
                    keyboardList.push('ArrowLeft');
                } else if (item === 'right arrow') {
                    keyboardList.push('ArrowRight');
                } else if (item === 'up arrow') {
                    keyboardList.push('ArrowUp');
                } else {
                    keyboardList.push(item);
                }
            });

            if (this.props.stageCover && keyboardList.indexOf(key) > -1) {
                this.props.vm.start();
                this.props.vm.greenFlag();
                this.props.setWorkButState(false);
                this.props.setStageCover();
            }
            this.props.vm.postIOData('keyboard', {
                keyCode: keyCode,
                key: key === 'any' ? '/' : key,
                isDown: true
            });
        }
    }

    handleKeyUp (key) {
        if (key) {
            const keyCode = this.state.keyCode.find(item => item.key === key).code;

            this.props.vm.postIOData('keyboard', {
                keyCode: keyCode,
                key: key === 'any' ? '/' : key,
                isDown: false
            });

        }
    }

    studentNameSlice() {
        // let name = this.props.workInfo.userName;
        // if (this.props.workIsShare && this.props.workInfo.userName && this.props.workInfo.userName.length > 1) {
        //     if (this.props.workInfo.userName.length <= 3) {
        //         name = this.props.workInfo.userName.slice(1);
        //     } else {
        //         name = this.props.workInfo.userName.slice(2);
        //     }
        // }
        return this.props.workInfo.userName;
    }

    render () {
        const {
            vm,
            setWorkButState,
            keyboard,
            isStarted,
            ...props
        } = this.props;
        return (
            keyboard &&
                <KeyBoardComponent
                    keyboard={this.filterKeyboardType()}
                    userName={this.studentNameSlice()}
                    keyList={keyboard}
                    onKeyPress={this.handleKeyPress}
                    onKeyUp={this.handleKeyUp}
                    {...props}
            />
        );
    }
}

Content.propTypes = {
    projectRunning: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM),
    keyboard: PropTypes.array,
    stageCover: PropTypes.bool,
    isStarted: PropTypes.bool,
    setWorkButState: PropTypes.func,
    workInfo: PropTypes.object,
    workIsShare: PropTypes.number
};

const mapStateToProps = state => ({
    projectRunning: state.scratchGui.vmStatus.running,
    vm: state.scratchGui.vm,
    keyboard: state.scratchGui.projectState.keyboard,
    stageCover: state.scratchGui.vmStatus.stageCover,
    isStarted: state.scratchGui.vmStatus.running,
    workInfo: state.scratchGui.projectState.workInfo,
    workIsShare: state.scratchGui.projectState.workIsShare,
});

const mapDispatchToProps = dispatch => ({
    setStageCover: () => dispatch(setStageCover()),
    setWorkButState: state => dispatch(setWorkButState(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
